import { useMemo } from "react";

import { useAuth } from "~/features/auth/contexts/AuthContext";
import { type ApiRequestContext } from "~/lib/apiClient";

export const useApiRequestContext = (): ApiRequestContext | undefined => {
  const { user, tenantId } = useAuth();

  return useMemo(() => {
    if (!user) {
      return undefined;
    }

    // `securityContext: "default"` matches what `AuthContext` writes into the
    // module-level request-context store. Omitting it makes `apiClient` fall
    // back to the tenantId, and the BE visibility index then silently returns
    // an empty list for anything the flavour loader seeded (it writes rows
    // under the canonical "default" context).
    return {
      tenantId,
      userProfileId: user.id,
      securityContext: "default",
    };
  }, [tenantId, user]);
};
